import { SalesforceBundleGroup } from "~/api/models/Bundle";
import {
  useFetchBundles,
  SalesforceBundle,
} from "~/api/salesForce/useFetchBundles";
import { useCheckoutStore } from "~/stores/checkout/useCheckoutStore";

export const useBundles = () => {
  const { data: bundles, isLoading } = useFetchBundles();
  const { setSelectedBundles, selectedBundles } = useCheckoutStore();

  const toggleBundle = (bundle: SalesforceBundle) => {
    const list = [...selectedBundles];
    const index = list.findIndex((selected) => selected.id === bundle?.id);

    if (bundle && index > -1) {
      list.splice(index, 1);
    } else if (bundle && index < 0) {
      list.push(bundle);
    }

    setSelectedBundles(list);
  };

  const removeBundles = (group?: SalesforceBundleGroup) => {
    setSelectedBundles(
      selectedBundles.filter((bundle) => bundle.group !== group)
    );
  };

  return {
    bundles,
    toggleBundle,
    isLoading,
    selectedBundles,
    removeBundles,
    setSelectedBundles,
  };
};
